/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Welcome/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function Welcome({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/ImageCapture/Questions/Question/Content/Welcome"
  
}) {
  let isBefore = useIsBefore()
  let isMedia = useIsMedia()
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
let imageCaptureQuestionInstructionsValueData = fromData.useDataValue({ viewPath,
context: 'imageCaptureQuestion',
path: 'instructions',
})
let dtTypographyFontsizeL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.l'
        })
let imageCaptureQuestionsValueData = fromData.useDataFormat({ viewPath,
context: 'imageCapture',
path: 'questions',
format: fromHelpers.welcomeText,
})
  return (<React.Fragment
>
<div
  data-testid="Welcome.Vertical"
  data-view-path={viewPath}
 style={{'--pt-1-Z1DTDk4': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pl-2-Z1DTDk4': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pr-3-Z1DTDk4': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--o-4-Z1DTDk4': isBefore ? 0 : 1}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Welcome.Vertical:1"
  data-view-path={viewPath}
 style={{'--w-5-Z1DTDk4': isMedia.mobile ? "100%" : "70%"}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 text="Welcome"
 color={dtColorsNeutral700}
 marginBottom={dtSpaceM}
 textAlign="center"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 textAlign="center"
 whiteSpace="wrap"
 fontSize={dtTypographyFontsizeL}
 marginBottom={dtSpaceM}
 data="imageCaptureQuestion.instructions"
 text={imageCaptureQuestionInstructionsValueData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 textAlign="center"
 whiteSpace="wrap"
 fontSize={dtTypographyFontsizeL}
 marginBottom={dtSpaceM}
 data="imageCapture.questions"
 format="helpers.js welcomeText"
 text={imageCaptureQuestionsValueData}
/>
</div>
</div>
{children}
</React.Fragment>)
}